export * from "./atoms";
export * from "./organisms";

import { RoomGroupAtoms } from "./atoms";
import { RoomGroupOrganisms } from "./organisms";

export const RoomGroupComponents = [...RoomGroupAtoms, ...RoomGroupOrganisms];
